import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/msalConfig";

export class ApiError extends Error {
  status: number;
  body: unknown;

  constructor(path: string, status: number, body: unknown) {
    super(`${path} → ${status}`);
    this.status = status;
    this.body = body;
  }
}

export function useApiFetch() {
  const { instance, accounts } = useMsal();
  return async function apiFetch(path: string, init?: RequestInit): Promise<Response> {
    const account = accounts[0];
    const result = await instance.acquireTokenSilent({ ...loginRequest, account });
    const headers = new Headers(init?.headers);
    headers.set("Authorization", `Bearer ${result.accessToken}`);
    if (init?.body && typeof init.body === "string" && !headers.has("Content-Type")) {
      headers.set("Content-Type", "application/json");
    }
    // Anchored to the app's base path, not the current route -- a plain
    // relative "api/..." resolves against the current URL's directory, so
    // a nested route like /intake/spend would resolve it to
    // /intake/api/..., missing the backend entirely and hitting the SPA's
    // HTML fallback instead (surfaces as "Unexpected token '<'").
    const res = await fetch(`${import.meta.env.BASE_URL}api/${path}`, { ...init, headers });
    if (!res.ok) {
      const body = await res.json().catch(() => null);
      throw new ApiError(path, res.status, body);
    }
    return res;
  };
}
